import { Shield, Eye, Heart } from "lucide-react";
import { motion } from "framer-motion";

const TRUST_ITEMS = [
  {
    icon: Eye,
    title: "Transparência",
    description: "Comunicação clara e relatórios detalhados para sua família acompanhar cada passo.",
  },
  {
    icon: Shield,
    title: "Escala Digna",
    description: "Profissionais valorizados, com carga horária justa e remuneração adequada.",
  },
  {
    icon: Heart,
    title: "Cuidado Humanizado",
    description: "Cada idoso é único. Nosso cuidado respeita sua história, seus hábitos e sua dignidade.",
  },
];

export default function TrustBlock() {
  return (
    <section className="section-padding gradient-sage">
      <div className="container">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-4 text-foreground">
          O que nos move
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          Mais do que um serviço, somos um compromisso com a dignidade e o bem-estar.
        </p>
        <div className="grid md:grid-cols-3 gap-8">
          {TRUST_ITEMS.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="bg-background rounded-xl p-8 text-center shadow-sm border border-border"
            >
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary/10 mb-5">
                <item.icon className="h-7 w-7 text-primary" />
              </div>
              <h3 className="font-display text-xl font-semibold mb-3 text-foreground">{item.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
